import { createStore, useStore } from 'zustand';

interface FeatureFlagsState {
  flags: Record<string, boolean>;
  setFlags: (flags: Record<string, boolean>) => void;
  isEnabled: (key: string) => boolean;
}

export const featureFlagsStore = createStore<FeatureFlagsState>()((set, get) => ({
  flags: {},
  setFlags: (flags) => {
    set({ flags });
  },
  isEnabled: (key) => get().flags[key] ?? false,
}));

export function useFeatureFlagsStore<T>(selector: (s: FeatureFlagsState) => T): T {
  return useStore(featureFlagsStore, selector);
}
